<template>
  <div>
    <Header />
    <b-container class="my-4">
      <b-row>
        <b-col cols="12" lg="4">
          <b-card
            class="mb-3 services-card"
            bg-variant="primary"
            text-variant="white"
            border-variant="light"
            overlay
            img-src="../assets/courts.jpg"
          >
            <div class="pt-3 d-flex">
              <h1 class="m-0 pr-3">
                <span class="icon-basketball-hoop"></span>
              </h1>
              <div>
                <h3>Canchas</h3>
                <p>
                  Tenemos 3 canchas de basketball y volleyball.
                </p>
                <b-button
                  variant="primary"
                  class="font-weight-bold stretched-link"
                  :to="{ name: 'Bookings' }"
                >
                  Reservar
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" lg="4">
          <b-card
            class="mb-3 services-card"
            bg-variant="warning"
            text-variant="white"
            border-variant="light"
            overlay
            img-src="../assets/birrias.jpg"
          >
            <div class="pt-3 d-flex">
              <h1 class="m-0 pr-3">
                <span class="icon-basketball"></span>
              </h1>
              <div>
                <h3>Juegos</h3>
                <p>
                  Partidos con <strong>Hoops 5×5 Challenge</strong> cuando quieras.
                </p>
                <b-button
                  variant="warning"
                  class="font-weight-bold stretched-link"
                  :to="{ name: 'Hoops5x5Challenge' }"
                >
                  Inscribe tú equipo
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" lg="4">
          <b-card
            class="mb-3 services-card"
            bg-variant="danger"
            text-variant="white"
            border-variant="light"
            overlay
            img-src="../assets/corpo.jpg"
          >
            <div class="pt-3 d-flex">
              <h1 class="m-0 pr-3">
                <span class="icon-trophy"></span>
              </h1>
              <div>
                <h3>Ligas</h3>
                <p>Organizamos ligas, en diferentes categorías.</p>
                <b-button
                  variant="danger"
                  class="font-weight-bold stretched-link"
                  :to="{ name: 'Leagues' }"
                >
                  Inscribe tú equipo
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue'
import Footer from '@/components/home/Footer.vue'
export default {
  components: {
    Header,
    Footer
  }
}
</script>
<style lang="scss" scoped>
.services-card {
  .position-relative {
    max-height: 300px;
    overflow:hidden;
    border-radius: 0.25rem;
    > img {
      filter: brightness(22%) opacity(75%);
    }
  }
}
</style>
